import React, { lazy, Suspense } from "react";

const Editor = lazy(() => import("components/shared/editor.js"));

const Markup = ({ renderField, renderFiles, editorValue, onChange, header, Button }) => {
    return (
        <>
            {renderField(header)}
            {renderFiles()}
            <div className="pb-3">
                <Suspense fallback={<div className="loading" />}>
                    <Editor value={editorValue} onChange={(value) => onChange({ name: "text", value })} />
                </Suspense>
            </div>
            {!!Button && <Button />}
        </>
    );
};

export default Markup;
